import axios from 'axios';
import { utilityService } from '@/services/utilityService.js';
import { authTokenService } from '@/services/authTokenService.js';

function __loadLookUp (lookUpType, fnCallback) {
  return axios.get(utilityService.getApiUrl('lookup/' + lookUpType),
    // Second parameter is the configuration object
    {
      headers: utilityService.getHeaders()
    }
  );
}

function __searchOrganizations (search, fnCallback) {
  return axios.post(utilityService.getApiUrl('lookup/organization/search'),
		search,
    // Third parameter is the configuration object
    {
      headers: utilityService.getHeaders()
    }
  );
}

function __searchOrganizationsAny (search, fnCallback) {
  return axios.post(utilityService.getApiUrl('lookup/organizationAny/search'),
		search,
    // Third parameter is the configuration object
    {
      headers: utilityService.getHeaders()
    }
  );
}

function __loadLookUpCountries (lookUpType) {
  return axios.get(utilityService.getApiUrl('lookup/countries/' + lookUpType),
    // Second parameter is the configuration object
    {
      headers: utilityService.getHeaders()
    }
  );
}

export const lookUpService = {
    loadLookUp: (lookUpType) => __loadLookUp(lookUpType),
    loadLookUpCountries: (lookUpType) => __loadLookUpCountries (lookUpType),
    searchOrganizations: (search) => __searchOrganizations(search),
    searchOrganizationsAny: (search) => __searchOrganizationsAny(search)
};
